import SelectBox from 'devextreme-react/select-box';
import React, { useEffect, useState } from 'react';
import { nguonBietToiApi } from '../../api/nguonBietToiApi';
import { useCommonContext } from '../../contexts/common';

const ComboboxNguonBietToi = ({ value, onValueChanged, cmb, width, dm_coso_id = 0 }) => {
  const { translate } = useCommonContext();

  const [nguonBietTois, setNguonBietTois] = useState([]);
  useEffect(() => {
    handleReloadQuanHes();
  }, []);
  const handleReloadQuanHes = async () => {
    const res = await nguonBietToiApi.SelectAll();
    if (res.is_success) {
      if (dm_coso_id > 0) {
        res.data = res.data.filter(x => x.dm_coso_id === dm_coso_id);
      }
      setNguonBietTois(res.data);
    }
  };
  return (
    <SelectBox
      dataSource={nguonBietTois}
      displayExpr={'nguon_biet_toi'}
      valueExpr={'id'}
      placeholder={translate('Chọn nguồn biết tới')}
      value={value}
      stylingMode="outlined"
      width={width || 120}
      ref={cmb}
      onValueChanged={(e) => {
        if (e.event) onValueChanged(e.value);
      }}
    />
  );
};

export default ComboboxNguonBietToi;
